import { Button, ButtonProps, Icon } from '@chakra-ui/react'
import { AppLayoutContextValue, useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext'
import React, { useMemo } from 'react'
import { IconType } from 'react-icons'
import { LuIndentIncrease } from 'react-icons/lu'

export type AppPanelToggleButtonProps = {
  appLayout?: AppLayoutContextValue
  icon?: IconType
  panelId: string
  panelPosition?: 'left' | 'right'
  buttonProps?: ButtonProps
}

export const AppPanelToggleButton = (props: AppPanelToggleButtonProps) => {
  const fallbackLayout = useParentAppLayout()
  const appLayout = props.appLayout || fallbackLayout
  const panelPosition = props.panelPosition || 'left'
  const isPanelOpen = appLayout.isPanelOpen?.(props.panelId) ?? false

  const transform = useMemo(() => {
    if (panelPosition === 'left') {
      if (isPanelOpen) {
        return 'rotate(180deg)'
      } else {
        return ''
      }
    } else {
      if (isPanelOpen) {
        return ''
      } else {
        return 'rotate(180deg)'
      }
    }
  }, [isPanelOpen, panelPosition])

  return (
    <Button
      aria-label={'Open Menu'}
      borderRadius={'md'}
      boxShadow={'none'}
      paddingX={0}
      size={'sm'}
      variant={'outlineGhost'}
      onClick={() => {
        appLayout.togglePanel?.(props.panelId)
      }}
      {...props.buttonProps}
    >
      <Icon as={props.icon || LuIndentIncrease} boxSize={4} color={'colorPalette.fg'} transform={transform} />
    </Button>
  )
}
